module.exports = __webpack_public_path__ + "static/media/e2access.4a9dabd7.svg";